import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid, Button, Typography } from '@mui/material';
import cardvideo1 from '../../../assets/cardvideo1.mp4';
import cardvide2 from '../../../assets/cardvideo2.mp4';
import cardvideo3 from '../../../assets/cardvideo3.mp4';
import Heading from '../../Components/LockerMenu/component/Heading';

const Wrapper = styled(Box)`
  padding: 90px 0px;
`;

const Paragraph = styled(Typography)`
  font-size: 18px;
  max-width: 720px;
  opacity: 0.5; 
  margin: 15px auto 60px;
  color: #666;
  line-height: 1.6;
`;

const CardContainer = styled(Box)`
  padding: 5px; 
  display: flex;
  border: none;
  flex-direction: column;
  align-items: center;
  position: relative;
  @media (max-width: 600px) {
     margin-bottom: 30px;
  }
`;

const CardTitle = styled(Typography)`
  font-size: 28px;
  font-weight: 500;
  color: #0A1038;
`;

const BlurOverlay = styled(Box)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 7%,
    rgba(255, 255, 255, 0.7) 41%,
    rgba(255, 255, 255, 0.85) 64%,
    rgba(255, 255, 255, 0.95) 76%,
    #ffffff 100%
  );
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;  
  align-items: center;
  padding-top: 170px;
  @media (max-width: 600px) {
   padding-top: 0px;
   justify-content: flex-end;
  }
`;

const ExploreButton = styled(Button)`
  background-color: #0A1038;
  color: white;
  padding: 15px 47px;
  border-radius: 12px;
  text-transform: none;
  font-weight: 500;
  margin-top: 10px;
  :hover {
    background: linear-gradient(150deg, #6C1EB2, #D14FA0); 
    color: #fff;
  }
`;

const VideoWrapper = styled(Box)`
  width: 100%;
  max-width: 800px;
  border-radius: 20px;
  height: 67vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (max-width: 600px) {
    height: 80vh;
  }
`;

const StyledVideo = styled('video')`
  width: 100%;
  height: 100%;
  border-radius: 13px;
  object-fit: cover;
  border: dotted;
  pointer-events: none;
`;

const SideOverlay = styled(Box)`
`;

const Categories = () => {
  const categoryCards = [
    {
      id: 3,
      title: 'Physical Goods',
      buttonText: 'Explore now',
      videoSrc: cardvideo3,
      link: 'https://aicm-store.gitbook.io/whitepaper/platform-expansion-plans/physical-goods-and-merchandise',  
    },
    {
      id: 2,
      title: 'Services',
      buttonText: 'Explore now',
      videoSrc: cardvide2,
      link: 'https://app.aicm.store/products/services/services',  
    },
    {
      id: 1,
      title: 'Digital Goods',
      buttonText: 'Explore now',
      videoSrc: cardvideo1,
      link: 'https://aicm-store.gitbook.io/whitepaper/platform-expansion-plans/crypto-centric-digital-services',  
    },
  ];

  return (
    <Wrapper>
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center" textAlign="center">
          <Grid item style={{ marginBottom: '-35px' }}>
            <Heading>Categories</Heading>
            <Paragraph>
              Redefining e-commerce with AI and blockchain. Buy, sell, and list physical products, digital goods, and specialized services seamlessly on AICM.
            </Paragraph>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          {categoryCards.map(card => (
            <Grid item xs={12} sm={6} md={4} key={card.id}>
              <CardContainer>
                <VideoWrapper>
                  <StyledVideo autoPlay loop muted playsInline>
                    <source src={card.videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                  </StyledVideo>
                  <BlurOverlay>
                    <CardTitle>{card.title}</CardTitle>

                    <a href={card.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                      <ExploreButton variant="contained" disableElevation>
                        {card.buttonText}
                      </ExploreButton>
                    </a>
                  </BlurOverlay>
                  <SideOverlay />
                </VideoWrapper>
              </CardContainer>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default Categories;
